import React from 'react'
import { useCallback } from 'sb-hooks'

import useModalVisibility from './useModalVisibility'
import { closeModal } from './manager'
import { ModalProps } from './Modal'


type WrappedComponentProps = {
  onClose?: () => void
}

// type for props after hook
export type ModalVisibilityProps = Partial<ModalProps> & {
  closeModal: () => void
  onClose: () => void
}

const modalVisibility = <TProps extends {}>(name: string, ComposedComponent) => {

  const WrappedComponent: React.FunctionComponent<WrappedComponentProps & TProps> = (initialProps) => {
    const { isVisible, props } = useModalVisibility<WrappedComponentProps & TProps>(name)

    const { onClose: initialOnClose } = initialProps
    const { onClose } = props || ({} as WrappedComponentProps)

    const handleClose = useCallback(() => {
      closeModal(name)

      if (typeof initialOnClose === 'function') {
        initialOnClose()
      }

      if (typeof onClose === 'function') {
        onClose()
      }
    }, [ initialOnClose, onClose ])

    const handleCloseModal = useCallback(() => {
      closeModal(name)
    }, [])

    return isVisible && (
      <ComposedComponent
        {...initialProps}
        {...props}
        onClose={handleClose}
        closeModal={handleCloseModal}
      />
    )
  }

  WrappedComponent.displayName = `modalVisibility(${ComposedComponent.displayName || ComposedComponent.name})`

  return React.memo(WrappedComponent)
}


export default modalVisibility
